import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component"
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFButton, ORFDatePicker
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { wirelessTerminateActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-terminate-subscription.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { MAX_LENGTH, CIRCUIT_STATUS } from "../../../../../constants/external-constants"
import { Loading } from '../../../../common/loading/index';
import { convertUtcToLocalDate } from '../../../../../utils/helpers.utils';
import {SUBMIT_REQUEST_TITLE} from "../../../../../constants/external-constants"

class MobileTerminateSubscriptionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            terminateDate: '',
            circuitCode: '',
            showConModal: false,
            isLoading: false,
            title: "",
            error: false,
            isSaving: false
        }
    }

   async componentWillMount() {
       const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
       const { requestData } = this.props.requestDetail;
       const { fetchSubscriptionByCircuitCode, fetchSubscriptionByValue, onSubscriptionSelect } = this.props;

       if (takeActionCircuitId != null || takeActionCircuitId !== undefined) {
           var circuitCodePropName = 'CircuitCode';
           var subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

           onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
       }
       else {
           onSubscriptionSelect('');
       }

       if (isUpdateRequest) {
           this.setState({ isLoading: true })
           let propName = 'CircuitCode';
           let requestOnBehalf = requestData.RequestedInBeHalfOf ? requestData.RequestedInBeHalfOf : null;
           await fetchSubscriptionByCircuitCode(requestData.Circuit.CircuitCode, propName, requestOnBehalf)
           this.props.setRequestSelectedData();
           this.setState({ isLoading: false })
       }
      
    }

    componentWillUnmount() {
        this.props.resetWirelessTerminateForm();
        this.props.resetRequestData();
    }

    setTerminateDate = (dt) => {
        if(dt !== ''){
            this.setState({
                terminateDate: dt
            });
        }
    }

    submitRequest = async () => {
        this.setState({showConModal:true})
    }

    isSameParam = () => {   
        const { circuitCode, businessJustification, additionalInformation, terminateDate } = this.props.wirelessTerminateFormA;
        const { requestData } = this.props.requestDetail;
        let isTermenateDt = (requestData.Order.OrderDisconnectDate ? new Date(convertUtcToLocalDate(requestData.Order.OrderDisconnectDate)) : '').toDateString() === (!terminateDate == false ? terminateDate.toDateString() : '');

        return (requestData.Circuit.CircuitCode === circuitCode
            && requestData.BusinessJustification.BusinessJustification === businessJustification
            && requestData.BusinessJustification.AdditionalInformation === additionalInformation
            && isTermenateDt)
    }
    validateData = () => {
        const { wirelessTerminateFormA } = this.props;
        const { formSubmitted } = this.props.wirelessTerminateRequest;
        const { requestOnBehalfData, isRequestOnBehalf, isUpdateRequest } = this.props.createRequest;
      
        if (!wirelessTerminateFormA.circuitId || !wirelessTerminateFormA.terminateDate || !wirelessTerminateFormA.businessJustification || formSubmitted) {
            return true;
        }

        if (isRequestOnBehalf) {
            if (requestOnBehalfData && requestOnBehalfData.EmployeeId > 0 && wirelessTerminateFormA.circuitCode !== '') {
                if (isUpdateRequest) {
                   return this.isSameParam();
                }
            }
        } else {
            if (isUpdateRequest) {
                return this.isSameParam();
            }
        }
      
        return false;
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleCloseNotif = () => {
        const { closeAction } = this.props;
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {
            closeAction();
        } 
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems } = this.props;
                this.setState({
                    isSaving: true,
                });
                var success = await submitRequest();
                let resultMessage = success.Message;
                if (success.Success) {
                    fetchRequestLogItems(0);
                    this.setState({
                        title: "Success",
                        isSaving: false
                    })

                    const { isUpdateRequest } = this.props.createRequest;
                    resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
                    this.props.hideRequestModal();
                }else {
                    this.setState({
                        title: "Error",
                        isSaving: false
                    })
                    resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
                }
                this.setState( prev => ({
                    showConModal: !prev.showConModal,
                    show:true, 
                    message: resultMessage,
                }))
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    render() {
        const { terminateDate, isLoading } = this.state;
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { wirelessTerminateFormA, onSubscriptionSelect, fetchSubscriptionByValue } = this.props;
        const { subscription, isResetLoading } = this.props.wirelessTerminateRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";

        return isLoading ?
            (<div>
                <Loading />
            </div>) : (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")} 
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelessTerminateFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row className='mh-70'>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea'>
                         {
                                  !isResetLoading && <SearchSuggestions
                                  value={wirelessTerminateFormA.circuitCode}
                                  label={this.toLocaleLanguage('mobile_phone_number')}
                                  propDisplay={'CircuitCode'}
                                  options={subscriptionList.length > 0 ? subscriptionList : ''}
                                  onChangeAction={onSubscriptionSelect}
                                  searchAction={fetchSubscriptionByValue}
                                  defaultValue={takeActionCircuitCode}
                                  placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                  errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                  haveError={this.haveError}
                              />
                         }
                        </Col>
                        {wirelessTerminateFormA.circuitCode != '' &&
                            <div className="pb-15-pl-30">
                                <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? subscriptionList[0].VendorName : subscription.VendorName != null && subscription.VendorName != "" ? subscription.VendorName : ""} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].PlanName ? subscriptionList[0].PlanName : <Translation translationKey="no_plan_available" />) : subscription.PlanName != null && subscription.PlanName != "" ? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].DeviceName ? subscriptionList[0].DeviceName :  <Translation translationKey="no_device_available" />): subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName
                                    : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>
                    <div className="text-field-container">
                        <span className='text-field-title'>TERMINATE REQUEST DETAILS</span>
                    </div>
                    <Row>
                        <Col xs={6} md={6} lg={6}>
                           <div className="date-picker-group">
                                <DATEPICKER_OR 
                                    label={`${this.toLocaleLanguage('terminate_date')}`}
                                    subLabel={`${this.toLocaleLanguage('parenthesis_effectivity_date')}` }
                                    startDate={wirelessTerminateFormA.terminateDate} 
                                    selectedDate={(date) => this.props.FormChange("wirelessTerminateFormA.terminateDate", date)}
                                    isDisable={wirelessTerminateFormA.circuitId == 0}
                                    minDate={new Date()}
                                    requiredField={true}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                /> 
                             </div>                        
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea' >
                            <TextArea
                                label={this.toLocaleLanguage('business_justification')}
                                fieldProp='.businessJustification'
                                value={wirelessTerminateFormA.businessJustification}
                                maxLength={MAX_LENGTH.limit_500}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='placeholder-padding-textarea' >
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessTerminateFormA.additionalInformation}
                                maxLength={MAX_LENGTH.limit_1000}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled= { this.validateData() }
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { createRequest, wirelessTerminateRequest, translation, requestDetail } = state;
        const { wirelessTerminateFormA } = state.form;
        return {
            wirelessTerminateFormA
            , createRequest
            , wirelessTerminateRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch => ({
        ...bindActionCreators(
            Object.assign({}, wirelessTerminateActions
                , createRequestActions
                , requestLogActions),
            dispatch
            ),
            FormChange: (Model, value) => {
                dispatch(actions.change(Model, value))
            }
     })
)(MobileTerminateSubscriptionForm);